import { render, staticRenderFns } from "./AppTablePagination.vue?vue&type=template&id=25c85616&scoped=true&"
import script from "./AppTablePagination.vue?vue&type=script&lang=js&"
export * from "./AppTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./AppTablePagination.vue?vue&type=style&index=0&id=25c85616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c85616",
  null
  
)

export default component.exports